import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { InformationRequest } from '../interfaces/informationRequest.interface';

@Injectable()
export class MinaMeddelandenService {
  constructor(
    protected http: HttpClient,
    @Inject('API_URL') protected apiUrl: string) {
  }

  public getMinaInfoRequests(instanceId: string): Observable<InformationRequest[]> {
    return this.http.get<InformationRequest[]>(`${this.apiUrl}/InformationRequest?instanceId=`);
  }
}
